{
  "cancel": "Cancelar",
  "delete": "Eliminar",
  "close": "Cerrar",
  "done": "Hecho",
  "deleteTitle": "¿Eliminar registro?",
  "deleteText": "¿Eliminar este registro de forma permanente?",
  "info": "Información",
  "objectInfoTitle": "Información del registro",
  "createdBy": "Creado por",
  "createdAt": "Creado el",
  "lastEditedBy": "Última edición por",
  "editedAt": "Editado el",
  "unknown": "Desconocido",
  "system": "Sistema",
  "objectHistoryTitle": "Registro e historia",
  "changes": "Cambios",
  "loadingHistory": "Cargando historial…",
  "noHistory": "Aún no hay historial de cambios.",
  "historyLoadError": "No se pudo cargar el historial.",
  "someone": "Alguien",
  "historyDate": "Fecha",
  "historyUser": "Usuario",
  "historyChange": "Cambio",
  "actionCreated": "creó",
  "actionDeleted": "eliminó",
  "actionChanged": "modificó",
  "historyFallbackWithTitle": "“{{title}}” {{verb}}",
  "historyFallback": "Entrada {{verb}}",
  "updateAvailable": "Actualización disponible",
  "updateBody": "Hay una nueva versión de esta aplicación disponible.\nSe requiere una actualización para obtener la mejor experiencia posible.",
  "updateLater": "Actualizar más tarde",
  "updateNow": "Actualizar",
  "internetRequired": "(Requiere conexión a internet)",
  "releaseInfo": "Notas de la versión",
  "selectMandant": "Seleccionar empresa",
  "noLicence": "No hay ninguna licencia disponible",
  "noCompanyAssigned": "No está asignado a ninguna empresa.",
  "companiesLoadError": "No se pudieron cargar las empresas",
  "logout": "Cerrar sesión"
}
